export const isForbiddenForInventoryItem = item => item.prod.forbiddenForInventory === true;
export const isForbiddenForInventoryItemExists = items => items.some(isForbiddenForInventoryItem);